export const CancellationPath = '/cancellation';

export const getCancellationTitle = (): string => 'Cancellation'; // TODO translate ?

export enum SCREEN {
  CANCEL_FORM = 'cancel_form',
  SUCCESS = 'success',
  FEEDBACK = 'feedback',
}
